import { render, staticRenderFns } from "./NewNewsletter.vue?vue&type=template&id=57d8646e&"
import script from "./NewNewsletter.vue?vue&type=script&lang=ts&"
export * from "./NewNewsletter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports